import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import i18n from './i18n'
import 'element-ui/lib/theme-chalk/index.css';
import './permission'
import "./styles/index.css";
import "./styles/common.css";
import "./styles/canToDo.css";
import { getCookie } from './utils/cookie';
import { domainName } from '@/utils/domainName'
Vue.use(ElementUI)
Vue.config.productionTip = false


Vue.prototype.$toUse = function() {
    const loginToken = getCookie("login_token");
    const userIdentity = store.state.userIdentity;

    // 业务意图：Token 写入发生在身份选择之前；只有身份确认完成后才允许进入工作台。
    if (loginToken && userIdentity) {
        location.href = domainName.api9
    } else {
        store.commit("setLoginDisplay", true);
    }
}
const isApi1 = window.location.origin == domainName.api1;
const isLocalhost = window.location.hostname == 'localhost';
if (isApi1 || isLocalhost) {
    let shouldRedirect = false;
    let newPath = '';
    if (window.location.hash.startsWith('#/')) { // 情况1：是旧的 hash 路由（需要转换）
        newPath = window.location.hash.slice(1); // "/start?..."
        shouldRedirect = true;
    } else if (isApi1) { // 情况2：已经是 history 模式，但域名不对（仅 api1 需要换域名）
        // 在 api1 上访问 history 模式路径，也要跳到 api1
        newPath = window.location.pathname + window.location.search + window.location.hash;
        shouldRedirect = true;
    }
    // 情况3：localhost + history 模式 → 不跳！本地开发就该留在 localhost
    // （否则会无限刷新）

    if (shouldRedirect) {
        const targetOrigin = isLocalhost ?
            'http://localhost:8068' // 本地只用于 hash → history 转换
            :
            domainName.api1; // api1 必须跳到 api1

        try {
            const newUrl = new URL(newPath, targetOrigin);
            // 额外保险：避免跳转到完全相同的 URL
            if (newUrl.href !== window.location.href) {
                window.location.replace(newUrl.href);
            }
        } catch (e) {
            console.error('重定向失败:', e);
        }
    }
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
